// extracted by mini-css-extract-plugin
export default {"link":"src-client-components-Link-styles-___default__link___hQyHw"};